import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BsGrid3X3GapFill, BsListStars } from 'react-icons/bs';
import { FaMapMarkedAlt } from 'react-icons/fa';
import { IoBookmarkOutline } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import BannerImageAd from '../../Component/BannerImageAd';
import BreadCrumb from '../../Component/BreadCrumb';
import Button from '../../Component/Button/Button';
import DropDown from '../../Component/DropDown/DropDown';
import EventCard from '../../Component/EventCard';
import EventFilters from '../../Component/EventFilters';
import EventHorizontalCard from '../../Component/EventHorizontalCard/EventHorizontalCard';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import { Loader } from '../../Component/Loader';
import NoData from '../../Component/NoData/NoData';
import { PaginationComponent } from '../../Component/Pagination/Pagination';
import Tabs from '../../Component/Tabs';
import Tooltip from '../../Component/Tooltip';
import MapMain from '../../Component/maps/MapMain';
import { isMobileViewHook } from '../../CustomHooks/isMobileViewHook';
import { restrictOnlyUserActions } from '../../Helper/restrictActions';
import {
  discardUndefinedOrNullValues,
  imageUrl,
  recordsLimit15,
  showTabsWhenUserIsLogin
} from '../../config/apiUrl';
import { eventFilterOptions } from '../../constant/commonData';
import EmailAgentModal from '../../modals/EmailAgentModal';
import SaveSearchModal from '../../modals/SaveSearchModal/SaveSearchModal';
import { useGetPublicEventsMutation, usePostApiMutation } from '../../store/apiSlice/apiSlice';
import { bannerConditions, generateBanners } from '../../utils/helpers';
import classes from './newEvents.module.css';

// const tabsData = [
//   { icon: <BsGrid3X3GapFill size={20} color="var(--white-clr)" />, text: 'grid', id: '1' },
//   { icon: <BsListStars size={22} color="var(--white-clr)" />, text: 'list', id: '2' },
//   { icon: <IoBookmarkOutline size={20} color="var(--white-clr)" />, text: 'save search', id: '3' }
// ];

function NewEvents() {
  const { eventTypes } = useSelector((state) => state?.commonReducer);

  const isSavedFilter = useLocation()?.state;

  const { t } = useTranslation('events');
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const [isMobile, setIsMobile] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState('');
  const { isLogin, user } = useSelector((state) => state.authReducer);
  const [getEvents, { isLoading, data }] = useGetPublicEventsMutation();
  const [mapProperties, setMapProperties] = useState(data?.data ?? []);
  const [showSaveSearch, setShowSaveSearch] = useState(false);
  const [saveSearchLoading, setSaveSearchLoading] = useState(false);
  const [postApiFunc] = usePostApiMutation();

  useEffect(() => {
    if (data?.data) {
      setMapProperties(data?.data);
    }
  }, [data]);

  const [page, setPage] = useState(1);
  const [selectedItem, setSelectedItem] = useState(null);
  const [filters, setFilters] = useState({
    province: null,
    town: null,
    neighborhood: null,
    nearby: null,
    entity: null,
    address: null,
    lng: null,
    lat: null,
    date: null,
    sortBy: null, // Add sortBy here
    sortType: null
  });

  const routeName = useLocation()?.pathname?.split('/')[1];
  const { allBanners } = useSelector((state) => state.commonReducer);

  const verticalBanners = allBanners?.filter(
    (item) => item?.page === routeName && item?.bannerType == 'vertical'
  );

 

  const horizontalBanners = generateBanners({
    allBanners,
    routeName,
    page
  });

  const getFilterModifyData = (fil) => {
    const filterData = {
      address: fil?.address,
      province: fil?.province?._id,
      town: fil?.town?._id,
      neighborhood: fil?.neighborhood?._id,
      eventType: fil?.entity?._id,
      nearby: !!fil?.nearby,
      ...(fil?.nearby || filters?.address
        ? {
            lng: fil?.lng,
            lat: fil?.lat
          }
        : {}),
      // Apply moment to format minDate and maxDate
      minDate: fil?.date?.[0]?.startDate
        ? moment(fil?.date?.[0]?.startDate).format('YYYY-MM-DD')
        : null,
      maxDate: fil?.date?.[0]?.endDate ? moment(fil?.date?.[0]?.endDate).format('YYYY-MM-DD') : null

      // address: filters?.address
    };

    return filterData;
  };

  const filtersToSearchParams = (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') return;

      if (Array.isArray(value)) {
        // Check if array contains objects
        const isObjectArray = value.some((item) => typeof item === 'object');
        if (isObjectArray) {
          params.set(key, JSON.stringify(value)); // Store whole array as JSON
        } else {
          params.set(key, value.join(',')); // Store primitive arrays as comma-separated
        }
      } else if (typeof value === 'object') {
        params.set(key, JSON.stringify(value)); // Store single object
      } else {
        params.set(key, value); // Primitive
      }
    });

    return params;
  };

  const searchParamsToFilters = (params) => {
    const filters = {};

    for (const [key, value] of params.entries()) {
      try {
        const parsed = JSON.parse(value);
        filters[key] = parsed;
      } catch {
        if (value.includes(',')) {
          filters[key] = value.split(',').map((v) => {
            try {
              return JSON.parse(v);
            } catch {
              return v;
            }
          });
        } else {
          filters[key] = value;
        }
      }
    }

    return filters;
  };
  const handleGetEvents = async (pg = page, fil = getFilterModifyData(filters)) => {
    if (fil.address && Array.isArray(fil.address)) {
      // If address is an array, join it into a single string
      fil = { ...fil, address: fil.address.join(',') };
    }

    const searchParams = filtersToSearchParams(fil);
    window.history.replaceState({}, '', `?${searchParams.toString()}`);

    await getEvents({
      page: pg,
      limit: recordsLimit15,
      data: {
        lan: selectedLanguage,
        ...discardUndefinedOrNullValues(fil)
      }
    });
  };

  const saveSearchData = showTabsWhenUserIsLogin(isLogin, [
    {
      icon: (
        <Tooltip text={t('tabs.saveSearch')}>
          <IoBookmarkOutline size={20} color="var(--primary-clr)" />
        </Tooltip>
      ),
      text: t('tabs.saveSearch'),
      value: 'save-search',
      id: '4'
    }
  ])[0];

  const tabsData = isMobile
    ? [
        {
          icon: (
            <Tooltip text={t('tabs.map')}>
              <FaMapMarkedAlt size={22} color="var(--arrowColor)" />
            </Tooltip>
          ),
          value: 'map',
          tooltipText: t('tabs.map'),
          id: '3'
        }
        // ,saveSearchData
      ]
    : [
        {
          icon: <BsGrid3X3GapFill size={20} color="var(--arrowColor)" />,
          tooltipText: t('tabs.grid'),
          value: 'grid',
          id: '1'
        },
        {
          icon: <BsListStars size={22} color="var(--arrowColor)" />,
          tooltipText: t('tabs.list'),
          value: 'list',
          id: '2'
        },
        {
          icon: <FaMapMarkedAlt size={22} color="var(--arrowColor)" />,
          value: 'map',
          tooltipText: t('tabs.map'),
          id: '3'
        }
        // ,saveSearchData
      ];
  const [selectedTab, setSelectedTab] = useState(tabsData[1]);
  useEffect(() => {
    
    isMobileViewHook(setIsMobile, 992);
  }, []);
  useEffect(() => {
    if (isMobile) {
      setSelectedTab({ text: 'list', id: '2' });
    }
  }, [isMobile]);

  function onSearch() {
    const pg = 1;
    setPage(pg);

    handleGetEvents(1, getFilterModifyData(filters));
  }

  const handleSaveSearch = async (title = '') => {
    const referenceObj = {
      province: filters?.province?._id,
      town: filters?.town?._id,
      neighborhood: filters?.neighborhood?._id,
      entity: filters?.entity?._id,
      title
    };
    const filterData = {
      nearby: filters?.nearby,
      ...(filters?.nearby || filters?.address
        ? {
            lng: filters?.lng,
            lat: filters?.lat
          }
        : {}),
      minDate: filters?.date?.[0]?.startDate,
      maxDate: filters?.date?.[0]?.endDate,
      address: filters?.address
    };

    let ifFilterHasSelected = Object.keys(
      discardUndefinedOrNullValues({
        ...referenceObj,
        ...filterData
      })
    );

    if (ifFilterHasSelected?.length === 0) {
      toast.warn(t('toast.noFilter'));
      return;
    }
    if (data?.data?.length === 0) {
      toast.warn(t('toast.noDataFound'));
      return;
    }

    if (isLoading) {
      toast.warn(t('toast.loadingData'));
      return;
    }

    setSaveSearchLoading(true);

    const response = await postApiFunc({
      url: `savedSearch`,
      method: 'POST',
      tag: `savedSearch`,

      data: discardUndefinedOrNullValues({
        data: discardUndefinedOrNullValues(filterData),
        ...referenceObj,
        type: 'event',
        pathName: window.location.pathname
      })
    });
    if (response?.data) {
      toast.success(t('toast.saveSearch'));
      handleGetEvents(page);
    }
    setShowSaveSearch(false);
    setSaveSearchLoading(false);
  };

  useEffect(() => {
    if (isSavedFilter) {
      let newData = {
        ...isSavedFilter,
        date: [
          {
            startDate: isSavedFilter?.minDate ? new Date(isSavedFilter?.minDate) : null,
            endDate: isSavedFilter?.maxDate ? new Date(isSavedFilter?.maxDate) : null,
            key: 'selection'
          }
        ]
      };
      delete newData?.minDate;
      delete newData?.maxDate;
      setFilters((prev) => ({
        ...prev,
        ...newData
      }));
      handleGetEvents(1, getFilterModifyData(newData));
    }
  }, [isSavedFilter]);



  useEffect(() => {
    if (isSavedFilter) return;

    const params = new URLSearchParams(window.location.search);
    if ([...params.keys()].length > 0) {
      const urlFilters = searchParamsToFilters(params);

      setFilters((prev) => ({
        ...prev,
        // ...urlFilters

        date: [
          {
            startDate: urlFilters?.minDate ? new Date(urlFilters.minDate) : null,
            endDate: urlFilters?.maxDate ? new Date(urlFilters.maxDate) : null,
            key: 'selection'
          }
        ],

        entity: eventTypes?.find((item) => item?._id == urlFilters?.eventType),
        address: Array.isArray(urlFilters?.address)
          ? urlFilters?.address?.join(',').trim()
          : urlFilters?.address?.trim()
      }));

      setTimeout(() => {
        handleGetEvents(1, urlFilters);
      }, 0);
    } else {
      handleGetEvents();
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsSticky(scrollTop > 90);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={classes.page}>
      <Header containerClass="" />
      <div className={[classes.filtersDiv, isSticky && classes.sticky].join(' ')}>
        <EventFilters
          containerClass=""
          showOneLine
          filtersWrapperClass={classes.filters}
          onSearch={onSearch}
          t={t}
          setFilters={setFilters}
          filters={filters}
          savedSearch={isSavedFilter}
          disabledSearch={isLoading}
        />
      </div>
     
      <Container className={classes?.contentContainer} fluid={selectedTab?.value === 'map'}>
        <Row className={classes.mainRow}>
          <Col md={5} className={classes.dataLeftStrip}>
            <BreadCrumb
              data={[
                {
                  title: 'Home',
                  path: '/'
                },
                {
                  title: 'Events',
                  active: true
                }
              ]}
            />
            <p className={classes.tabsDiv__highlight2}>
              {data?.totalRecords ?? 0} {t('tabs.title')}
            </p>
          </Col>
          <Col md={7}>
            <div className={classes?.dataStripRight}>
              {/* <span>{t('sortBy')} </span> */}
              <DropDown
                borderRadius="35px"
                className={classes?.dropdown}
                classNamePrefix={'smDropdown'}
                options={eventFilterOptions}
                value={eventFilterOptions.find((option) => option.value === filters.sortType)}
                setValue={(e) => {
                  setFilters((prevFilters) => ({
                    ...prevFilters,
                    sortType: e?.value
                  }));
                  setPage(1);
                  handleGetEvents(1, { ...filters, sortType: e?.value }); // Call handleGetProjects with updated filters
                }}
                optionLabel={[selectedLanguage]}
                optionValue={'value'}
                placeholder={t('sortBy')}
                customStyle={{
                  height: '44px',
                  fontSize: '14px'
                }}
              />
              {saveSearchData && (
                <Button
                  borderRadius="50px"
                  label={saveSearchData?.text}
                  leftIcon={saveSearchData?.icon}
                  variant="white"
                  onClick={() => {
                    const isAllowedActions = restrictOnlyUserActions(user?.role);
                    if (!isAllowedActions) return;
                    setShowSaveSearch(true);
                    
                  }}
                  className={classes.saveButton}
                />
              )}
              <Tabs
                separatorColor="var(--white-clr)"
                tabClass={classes.tab}
                setValue={(e) => {
                  if (isMobile && e?.value === selectedTab?.value) {
                    setSelectedTab({ value: 'list' });
                  } else {
                    setSelectedTab(e);
                  }
                  
                }}
                value={selectedTab}
                tabsData={tabsData}
              />
            </div>
          </Col>
          <Col
            md={selectedTab?.value == 'map' ? 12 : 10}
            className={[
              selectedTab?.value !== 'map' && 'verticalBannerAndContentWidth',
              classes.col1
            ].join(' ')}>
            {isLoading ? (
              <Loader className={classes?.loader} />
            ) : (
              <Row
                className={[classes.innerRow, selectedTab?.value == 'map' && classes.h100].join(
                  ' '
                )}>
                {selectedTab?.value == 'map' ? (
                  <>
                    {/* --------------------- MAP View Start ----------------------- */}

                    <Col
                      xl={{ span: 5, order: 1 }}
                      xs={{ span: 12, order: 2 }}
                      className={`scroller ${classes.mapLisingCards}`}>
                      <Row className={classes.mapList}>
                        {/* {data?.data?.slice(0, 9)?.map((item, key) => ( */}
                        {mapProperties?.map((item, key) => (
                          <Col xl={6} lg={4} sm={6} key={`${item?._id}-${key}`}>
                            <EventCard
                              data={item}
                              onEmailClick={() => {
                                setIsModalOpen('email');
                              }}
                              refetch={handleGetEvents}
                            />
                          </Col>
                        ))}
                      </Row>
                    </Col>
                    <Col xl={{ span: 7, order: 2 }} xs={{ span: 12, order: 1 }}>
                      <MapMain
                        showLandMarks={false}
                        className={classes.mainMap}
                        mapClass={classes?.mapClass}
                        zoom={5.5}
                        mapProperties={data?.data}
                        setMapProperties={setMapProperties}
                        showMarker={false}
                      />
                    </Col>
                    {/* --------------------- MAP View End ----------------------- */}
                  </>
                ) : data?.data?.length == 0 ? (
                  <NoData text={t('noDataText')} />
                ) : (
                  data?.data?.map((item, key) => (
                    <>
                      <Col
                        md={selectedTab?.value == 'list' ? 12 : 6}
                        lg={selectedTab?.value == 'list' ? 12 : 4}
                        sm={12}
                        key={`${item?._id}-${key}`}>
                        {selectedTab?.value == 'list' ? (
                          <EventHorizontalCard
                            data={item}
                            index={`${item?._id}-${key}`}
                            className={'mb-0'}
                            onEmailClick={() => {
                              setSelectedItem(item);
                              setIsModalOpen('email');
                            }}
                            refetch={handleGetEvents}
                          />
                        ) : (
                          <EventCard
                            data={item}
                            onEmailClick={() => {
                              setSelectedItem(item);
                              setIsModalOpen('email');
                            }}
                            refetch={handleGetEvents}
                          />
                        )}
                      </Col>
                   
                      {
                        // selectedTab?.value === 'list' &&
                        horizontalBanners?.length > 0 &&
                          bannerConditions[selectedTab?.value].renderCondition(key) && (
                            <Col md={12}>
                              <div className={classes?.bannerAdContainer}>
                                <BannerImageAd
                                  className={classes.horizontalBanner}
                                  image={imageUrl(
                                    horizontalBanners[bannerConditions.renderContentCondition(key)]
                                      .image
                                  )}
                                  link={
                                    horizontalBanners[bannerConditions.renderContentCondition(key)]
                                      ?.link
                                  }
                                />
                              </div>
                            </Col>
                          )
                      }
                    </>
                  ))
                )}

                {['list', 'grid'].includes(selectedTab?.value) && !!data?.data?.length && (
                  <Col md={12} className="jCenter">
                    <PaginationComponent
                      totalPages={Math.ceil(data?.totalRecords / recordsLimit15)}
                      setCurrentPage={(e) => {
                        setPage(e);
                      
                        handleGetEvents(e, getFilterModifyData(filters));
                      }}
                      currentPage={page}
                    />
                  </Col>
                )}
              </Row>
            )}
          </Col>
          <Col
            md={2}
            className={[
              selectedTab?.value == 'map' && 'd-none',
              'verticalBannerWidth',
              classes.col2
            ].join(' ')}>
            <Row className={`${classes.bannerRow}`}>
              {
              
                verticalBanners?.map((item, key) => (
                  <Col key={`${item?._id}-${key}`} md={12} className={key == 1 && classes?.bannerCol}>
                    <BannerImageAd
                      image={imageUrl(item?.image)}
                      link={item?.link}
                      className={classes.verticalBanner}
                    />
                  </Col>
                ))
              }
            </Row>
          </Col>
        </Row>
      </Container>
      <Footer />
      {isModalOpen == 'email' && (
        <EmailAgentModal
          show={isModalOpen == 'email'}
          setShow={setIsModalOpen}
          data={selectedItem}
          type={'event'}
        />
      )}

      {showSaveSearch && (
        <SaveSearchModal
          show
          t={t}
          setShow={setShowSaveSearch}
          onClick={(title) => handleSaveSearch(title)}
          loading={saveSearchLoading}
          inquiryType={'inquiry'}
        />
      )}
    </div>
  );
}

export default NewEvents;
